import { render, staticRenderFns } from "./CompanyAddress.vue?vue&type=template&id=96412a42&"
import script from "./CompanyAddress.vue?vue&type=script&lang=js&"
export * from "./CompanyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports